export const styles = () => ({
    container: {
        padding: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
    },
    workloadGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap: '1rem',
    },
    workloadCard: {
        border: '0.5px solid',
        borderColor: 'divider',
        borderRadius: '12px',
        backgroundColor: 'background.paper',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        minWidth: 0,
    },
    workloadName: {
        fontWeight: 600,
    },
    workloadCount: {
        color: 'text.secondary',
        fontSize: '0.875rem',
    },
    workloadBar: {
        height: 6,
        borderRadius: 3,
    },
    queue: {
        border: '0.5px solid',
        borderColor: 'divider',
        borderRadius: '12px',
        backgroundColor: 'background.paper',
    },
    leadRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        padding: '0.75rem 1rem',
        borderBottom: '0.5px solid',
        borderColor: 'divider',
        '&:last-child': {borderBottom: 'none'},
    },
    leadSummary: {
        flex: 1,
    },
    leadName: {
        fontWeight: 600,
    },
    leadDetail: {
        color: 'text.secondary',
        fontSize: '0.875rem',
    },
    responsibleSelect: {
        minWidth: 220,
    },
    emptyQueue: {
        padding: '1.5rem',
        color: 'text.secondary',
        textAlign: 'center',
    },
});
